import { transport } from "@/src/config/apiConfig.js";

export default {
  async fetchEmailActivity(id) {
    const response = await transport.get(`/api/emails/${id}/activity`);
    return response.data;
  },
  async fetchEmails(current, pageSize, filters) {
    const params = {
      page: current,
      page_size: pageSize,
      ...filters,
    };
    const response = await transport.get("/api/emails", {
      params: params,
    });
    return response.data;
  },
  async exportEmails(exportData, filters = {}) {
    // Create payload with export data and filters
    const payload = {
      ...exportData,
      ...filters,
    };

    const response = await transport.post("/api/emails/export", payload);
    return response.data;
  },

  async addEmailsToList(payload, filters = {}) {
    // Create payload with export data and filters
    const requestPayload = {
      ...payload,
      ...filters,
    };

    const response = await transport.post(
      "/api/entity_lists/email/add",
      requestPayload,
    );
    return response.data;
  },

  async addEmailsToSequence(id, payload, filters = {}) {
    // Create payload with export data and filters
    const requestPayload = {
      ...payload,
      ...filters,
    };

    const response = await transport.post(
      `/api/sequences/${id}/add_email_entities_to_sequence`,
      requestPayload,
    );
    return response.data;
  },
};
